import { Main } from '../../../../components/Main';

export const Inventory = () => {
  return (
    <Main title="Inventário">
      <h1>Pagina de Inventário</h1>
    </Main>
  );
};
